import MyBanner from "./myBanner/MyBanner"

export const Home = () => {

    return (
        <div>
            <MyBanner />
        </div>
    )
}